module.exports = __webpack_public_path__ + "img/1F1F3-1F1E8.ebabd48c.svg";